__turbopack_context__.v({
  "controlWrapper": "formItem-module-scss-module__QhSYVG__controlWrapper",
  "explain": "formItem-module-scss-module__QhSYVG__explain",
  "inheritLabel": "formItem-module-scss-module__QhSYVG__inheritLabel",
  "isError": "formItem-module-scss-module__QhSYVG__isError",
  "labelWrapper": "formItem-module-scss-module__QhSYVG__labelWrapper",
  "message": "formItem-module-scss-module__QhSYVG__message",
  "wrapper": "formItem-module-scss-module__QhSYVG__wrapper",
});
